


































import {Vue, Prop, Component} from 'vue-property-decorator';
import CreatePassengerGroup from '@/components/Organization/CreatePassengerGroup.vue';
import Routes from '../../Routes';
import { PassengerGroup } from '@/models/PassengerGroup';

@Component({
  components: {
    CreatePassengerGroup,
  }
})
export default class PassengerGroupsPage extends Vue {
  dialog = false;
  loading = true;
  search: string = '';
  passengerGroups: PassengerGroup[] = [];

  pagination = {
      rowsPerPage: 25 // -1 for All,
  }

  // @Prop() private organizationId!: string;

  get organizationId() {
    return this.$router.currentRoute.params.organizationId;
  }

  get headers() {
    const headers = [
      { text: this.$t('organization.passengerGroup.name', 'Name'),
        value: 'name', align: 'left', sortable: true },
        { text: this.$t('organization.passengerGroup.description', 'Descritption'),
        value: 'name', align: 'left', sortable: true },
        { text: this.$t('organization.passengerGroup.passengerCount', 'Passenger count'),
        value: 'name', align: 'left', sortable: true },
    ];

    return headers;
  }

  async mounted() {
    this.loading = true;
    this.passengerGroups = [];
    const result = await this.$store.dispatch('organization/getPassengerGroups',
     { params: { id: this.organizationId } });
    this.passengerGroups = result.data;
    this.loading = false;
  }

  openPassengerGroup(passengerGroup: PassengerGroup ) {
    this.$router.push({ 
      name: Routes.passengerGroup.name,
      params: { 
            organizationId: this.organizationId,
            passengerGroupId: passengerGroup.id.toString(),
          }, 
        });
  }

};
